// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1KRjG","dragIcon":"Choice_dragIcon__1KIS7","left":"Choice_left__A52Yq","input":"Choice_input__2Wsez"};